module.exports = __webpack_public_path__ + "static/media/jumanji-2017.369fc080.png";